import React, { Component } from "react";
import { Icon } from "@iconify/react";
import arrowUpBox from '@iconify/icons-mdi/arrow-up-box';
import { Link as Scroll } from "react-scroll";

class ScrollTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            style: "scroll-top in-top"
        }

    }
    async componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        
    }

    handleScroll = () => {
        if (window.scrollY >= 800) {
            this.setState({
                style: "scroll-top scrolled"
            })
        }else{
            this.setState({
                style: "scroll-top"
            })
        }
    }




    render() {
        const style = this.state.style;
        return (
            <>
                <Scroll
                    className={style}
                    to="start"
                    duration={800}
                    smooth={true}
                >
                    <Icon icon={arrowUpBox} className="icon" color="#0196d5" width="45" height="45" />
                </Scroll>
            </>
        )
    };

}


export default ScrollTop;